var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"text-left",attrs:{"cols":"12"}},[_c('span',{staticClass:"ntitlesdark--text font-weight-medium font-size-2"},[_vm._v(_vm._s(_vm.titleInput))])])
}
var staticRenderFns = []

export { render, staticRenderFns }